import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a34bf6e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5a34bf6e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a34bf6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a34bf6e')) {
      api.createRecord('5a34bf6e', component.options)
    } else {
      api.reload('5a34bf6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5a34bf6e&scoped=true", function () {
      api.rerender('5a34bf6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/menus/index.vue"
export default component.exports